import React, { Component } from 'react'

import { AmountInput } from '../AmountInput'
import { Button } from '../Button'
import { CheckboxOption } from '../CheckboxOption'

type Props = {
  number: number
  question: string
  subText?: string
  type: 'multiple-choice' | 'amount'
  options?: { value: string; text: string }[]
  value: null | string
  onChange: (value: string) => void
  onNext?: () => void
}

export class CalculatorQuestion extends Component<Props> {
  render = () => {
    const props = this.props
    const isDisabled = !props.value
    return (
      <div className="calculator-question mb-2">
        <span className="tag-purple">Question {props.number}</span>
        <h5 className="mt-0-5">{props.question}</h5>
        {props.subText && <p>{props.subText}</p>}
        <div className="mt-1-5">
          {props.type === 'amount' && (
            <AmountInput
              value={props.value}
              onChange={props.onChange}
              onSubmit={() => !isDisabled && props.onNext && props.onNext()}
            />
          )}
          {props.type === 'multiple-choice' && (
            <>
              {props.options.map(o => (
                <CheckboxOption
                  key={o.value}
                  {...o}
                  onClick={props.onChange}
                  isChecked={props.value === o.value}
                />
              ))}
            </>
          )}
        </div>
        {props.onNext && (
          <Button disabled={isDisabled} className="mt-2" onClick={props.onNext}>
            Next
          </Button>
        )}
      </div>
    )
  }
}
